export default __webpack_public_path__ + "static/media/loader.c947917c.svg";